import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPencilRegularRenameIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m2.8 10.3.5-1L10 2.6a1.6 1.6 0 0 1 2.3 0l.8.8q.5.6.5 1.2 0 .8-.5 1.2l-6.7 7-.8.4-3 .9q-.2 0-.4-.2l-.2-.5zm8-7L9.4 4.5l1.6 1.7 1.2-1.3.2-.4q0-.2-.2-.4l-.8-.8-.4-.2q-.2 0-.4.2m-2 2L4.5 9.8 6 11.4 10.4 7zm-5.5 7.3 1.9-.5-1.4-1.4zm5 .3h6.2q.5 0 .5.5t-.5.6H8.3a1 1 0 0 1-.5-.6q0-.5.5-.5" })
});
export default SvgPencilRegularRenameIcon;
